/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'index.js';
import { apiUrl } from 'App.js';

export const fetchAsyncRegisterFreePlanDefaultMarketInfo = createAsyncThunk(
  'freePlan',
  async (_, thunkAPI) => {
    const { otherSelectedBrand } = thunkAPI.getState().brand;
    const { channel, channelName, benchmark } =
      thunkAPI.getState().currentchannel;
    const { accountId } = thunkAPI.getState().user;
    const {
      a_cate1,
      a_cate2,
      a_cate3,
      a_cate4,
      a_cate5,
      a_cate6,
      r_cate1,
      r_cate2,
      r_cate3,
      r_cate4,
      r_cate5,
      r_cate6,
      y_cate1,
      y_cate2,
      y_cate3,
      y_cate4,
      y_cate5,
      y_cate6
    } = thunkAPI.getState().categorygraph;
    let categories = [];
    if (channel === 1) {
      categories = [a_cate1, a_cate2, a_cate3, a_cate4, a_cate5, a_cate6];
    } else if (channel === 2) {
      categories = [r_cate1, r_cate2, r_cate3, r_cate4, r_cate5, r_cate6];
    } else if (channel === 3) {
      categories = [y_cate1, y_cate2, y_cate3, y_cate4, y_cate5, y_cate6];
    }
    let level = 0;
    let currentId = 'all';
    let currentName = '';

    for (let i = categories.length - 1; i >= 0; i--) {
      // iを逆順にして最下層から見ていく
      // categories[i]が0の場合はスキップ
      if (categories[i] === 0 || categories[i] === undefined) {
        continue;
      } else {
        level = i + 1;
        currentId = categories[i].value; // categories[i]がオブジェクトなのでvalueを参照
        currentName = categories[i].label;
        break; // 最初に有効なカテゴリを見つけたらループを終了
      }
    }

    const res = await client.post(`${apiUrl}free_plan/default_market_info`, {
      account_id: accountId,
      channel: channel,
      category_id: currentId,
      category_name: currentName,
      brand_name: otherSelectedBrand[channelName].brand
    });
    return res.data;
  }
);

const initialState = {
  freePlanRegisterSuccess: false
};
const fetchFreePlanDefaultMarketSlice = createSlice({
  name: 'freePlanInfo',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(
      fetchAsyncRegisterFreePlanDefaultMarketInfo.fulfilled,
      (state, action) => {
        return {
          ...state,
          freePlanRegisterInfosSuccess: true
        };
      }
    );
    builder.addCase(
      fetchAsyncRegisterFreePlanDefaultMarketInfo.rejected,
      (state, action) => {
        // console.log('登録失敗', action.payload);
        return {
          ...state,
          freePlanRegisterInfosSuccess: false
        };
      }
    );
  }
});

// export const freePlanRegisterInfosSuccess = (state) =>
//   state.freePlan.freePlanRegisterInfosSuccess;

export default fetchFreePlanDefaultMarketSlice.reducer;
